import { deleteData, getData, patchData, postData } from "../api/api";
import type {
  AnomalyEvent,
  CreateAnomalyEventRequest,
  UpdateAnomalyEventRequest,
} from "../types/anomalyEvent";
import { buildReadQueryString } from "../lib/api/readQuery";

const ANOMALY_EVENT_BASE_URL = "/anomaly-event";

export const anomalyService = {
  getAnomalyEvents: async (
    page: number = 0,
    size: number = 50,
    search?: string,
    fields?: string | string[],
  ) => {
    const searchParam = search
      ? `category=ilike=${search};subCategory=ilike=${search};definition=ilike=${search};sourceSystemType=ilike=${search};defaultSeverity=ilike=${search}`
      : undefined;

    return getData(
      `${ANOMALY_EVENT_BASE_URL}/read?${buildReadQueryString({
        page,
        size,
        sort: "createdDate,desc",
        search: searchParam,
        fields,
      })}`,
    );
  },

  getAnomalyEventsByCustomerId: async (customerId: string, page: number = 0, size: number = 50) => {
    return getData(`${ANOMALY_EVENT_BASE_URL}/customers/${customerId}?page=${page}&size=${size}&sort=createdDate,desc`);
  },

  getAnomalyEvent: async (id: string) => {
    return getData(`${ANOMALY_EVENT_BASE_URL}/read/${id}`) as Promise<AnomalyEvent>;
  },

  createAnomalyEvent: async (data: CreateAnomalyEventRequest) => {
    return postData(`${ANOMALY_EVENT_BASE_URL}/create`, data);
  },

  updateAnomalyEvent: async (data: UpdateAnomalyEventRequest) => {
    return patchData(`${ANOMALY_EVENT_BASE_URL}/update`, data);
  },

  deleteAnomalyEvent: async (recordId: string) => {
    return deleteData(`${ANOMALY_EVENT_BASE_URL}/delete/${recordId}`);
  },
};
